import { Tasks } from "./Tasks.container";

// Default export needed
// eslint-disable-next-line import/no-default-export
export default Tasks;
